/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertStorageBindingDefaultRequest
 */
export interface UpsertStorageBindingDefaultRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertStorageBindingDefaultRequest
     */
    purpose?: UpsertStorageBindingDefaultRequestPurposeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpsertStorageBindingDefaultRequest
     */
    storageAccountId?: string;
}


/**
 * @export
 */
export const UpsertStorageBindingDefaultRequestPurposeEnum = {
    IntegrationPipeline: 'INTEGRATION_PIPELINE',
    SecureFiles: 'SECURE_FILES'
} as const;
export type UpsertStorageBindingDefaultRequestPurposeEnum = typeof UpsertStorageBindingDefaultRequestPurposeEnum[keyof typeof UpsertStorageBindingDefaultRequestPurposeEnum];


/**
 * Check if a given object implements the UpsertStorageBindingDefaultRequest interface.
 */
export function instanceOfUpsertStorageBindingDefaultRequest(value: object): value is UpsertStorageBindingDefaultRequest {
    return true;
}

export function UpsertStorageBindingDefaultRequestFromJSON(json: any): UpsertStorageBindingDefaultRequest {
    return UpsertStorageBindingDefaultRequestFromJSONTyped(json, false);
}

export function UpsertStorageBindingDefaultRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertStorageBindingDefaultRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'storageAccountId': json['storageAccountId'] == null ? undefined : json['storageAccountId'],
    };
}

export function UpsertStorageBindingDefaultRequestToJSON(json: any): UpsertStorageBindingDefaultRequest {
    return UpsertStorageBindingDefaultRequestToJSONTyped(json, false);
}

export function UpsertStorageBindingDefaultRequestToJSONTyped(value?: UpsertStorageBindingDefaultRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purpose': value['purpose'],
        'storageAccountId': value['storageAccountId'],
    };
}

